import store from "@/store"
import {AxiosMenuListRepository} from "@/models/Menu/AxiosMenuListRepository";

export function toggleMenu(state) {
    state.showNavMenu = !state.showNavMenu;
}

export function hideMenu(state) {
    state.showNavMenu = false;
}

export function showMenu(state) {
    state.showNavMenu = true;
}


export async function renderApp(state) {
    const user = store.getters["auth/getUser"];

    if(user) {
        // fill routes
        //state.rolesAvailable = await RoleService.all();
        state.rolesOfUser = user.user_roles.map(role => role.guard_name);
        state.items = await AxiosMenuListRepository.getAll()
        // render menu
        // validate menu-items
        // render activate
        store.commit('menu/validateMenu')
    }
}

export async function validateMenu(state) {
    state.showNavMenu = true
}
